import { checkErrorExist, convertError } from './converters';
import { apiWrapper } from './helpers';
import { handleFirstResponse } from '../utils/util_api_response';
import { getGlobalState, STATE_KEYS } from '../configs/config_state';

import GLOBAL from '../configs/config_global';

// region Get Catering List
/**
 * @param truckID {number} - ID of truck profile
 * @param currentPage {number} - page order to fetch data
 * @param pageSize {number} - number of results per page
 * @param getUnconfirmedOnly {boolean} - only get hired (and unconfirmed) catering leads
 */
export function getCateringList(truckID, currentPage = 1, pageSize = 200, getUnconfirmedOnly = false) {
    return apiWrapper(
        `/vendor/v1/foodtrucks/${truckID}/catering?page=${currentPage}&per_page=${pageSize}` + (getUnconfirmedOnly ? '&confirmed_status=0' : ''),
        'GET',
        'GET CATERING LIST'
    );
}
// endregion

// region Get Catering Detail
export function getCateringDetail(truckID, cateringID) {
    return apiWrapper(
        `/vendor/v1/foodtrucks/${truckID}/catering/${cateringID}`,
        'GET',
        'GET CATERING DETAIL'
    );
}
// endregion

// region Get Hoods List
export function getHoodList(truckID, currentPage = 1, pageSize = 20) {
    return apiWrapper(
        `/vendor/v1/foodtrucks/${truckID}/hoods?page=${currentPage}&per_page=${pageSize}`,
        'GET',
        'GET HOOD LIST'
    );
}
// endregion

// region Get Catering Detail
export function getHoodDetail(truckID, hoodID) {
    return apiWrapper(
        `/vendor/v1/foodtrucks/${truckID}/hoods/${hoodID}`,
        'GET',
        'GET HOOD DETAIL'
    );
}
// endregion

// region Update Truck Ordering Options in Hood
export function updateTruckOrderingOptions(hoodID, orderingOptions = []) {
    return apiWrapper(
        `/vendor/v1/foodtrucks/${getGlobalState(STATE_KEYS.TRUCK_DATA).id}/hoods/${hoodID}`,
        'POST',
        'UPDATE TRUCK ORDERING OPTIONS IN HOOD',
        JSON.stringify({ 'ordering_options': orderingOptions }),
        () => {},
        { 'Content-Type': 'application/json' }
    );
}
// endregion

// region Accept Catering Request
export function acceptCateringRequest(truckID, cateringID) {
    return new Promise((resolve, reject) => {
        fetch(GLOBAL.FATHER_LINK + `/vendor/v1/foodtrucks/${truckID}/change-catering-status/${cateringID}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + GLOBAL.DATA.USER_TOKEN
            },
            body: JSON.stringify({ status: 1 }),
            timeout: 10000
        })
            .then((response) => {
                const statusCode = response.status;

                // Parse response to JSON
                response.json()
                    .then((finalResponse) => {
                        if (!finalResponse.hasOwnProperty('errors')) {
                            console.log('[SUCCESS] ACCEPT CATERING REQUEST', finalResponse);
                            resolve(finalResponse);
                        }
                        else {
                            console.log('[FAILED] ACCEPT CATERING REQUEST (Status Code: ' + statusCode + ')', finalResponse);
                            reject(convertError(finalResponse['errors']));
                        }
                    });
            })
            .catch((error) => {
                console.log('[FAILED] ACCEPT CATERING REQUEST', error);
                reject(error.message);
            });
    });
}
// endregion

// region Update Catering Reminder Status
export function updateCateringReminderStatus(truckID, cateringID, status, declineReason) {
    return apiWrapper(
        `/vendor/v1/foodtrucks/${truckID}/catering/${cateringID}/catering-reminder`,
        'POST',
        'UPDATE CATERING REMINDER STATUS',
        JSON.stringify(Object.assign({ status }, declineReason?.trim() ? { truck_note: declineReason } : {})), // 1: Confirmed - 2: Can't make it
        () => {},
        { 'Content-Type': 'application/json' }
    );
}
// endregion

// region Update Hood Reminder Status
export function updateHoodReminderStatus(truckID, hoodID, status, declineReason) {
    return apiWrapper(
        `/vendor/v1/foodtrucks/${truckID}/hoods/${hoodID}/hood-reminder`,
        'POST',
        'UPDATE HOOD REMINDER STATUS',
        JSON.stringify(Object.assign({ status }, declineReason?.trim() ? { truck_note: declineReason } : {})), // 1: Confirmed - 2: Can't make it
        () => {},
        { 'Content-Type': 'application/json' }
    );
}
// endregion

// region Reject Catering Request
export function declineCateringRequest(truckID, cateringID) {
    return new Promise((resolve, reject) => {
        fetch(GLOBAL.FATHER_LINK + `/vendor/v1/foodtrucks/${truckID}/change-catering-status/${cateringID}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + GLOBAL.DATA.USER_TOKEN
            },
            body: JSON.stringify({ status: 2 }),
            timeout: 10000
        })
            .then((response) => response.json())
            .then((response) => {
                if (!response.hasOwnProperty('errors')) {
                    console.log('[SUCCESS] REJECT CATERING REQUEST', response);
                    resolve(response);
                }
                else {
                    console.log('[FAILED] REJECT CATERING REQUEST', response);
                    reject(convertError(response['errors']));
                }
            })
            .catch((error) => {
                console.log('[FAILED] REJECT CATERING REQUEST', error);
                reject(error.message);
            });
    });
}
// endregion

// region Mark Catering Lead as Hired
export function markAsHired(truckID, cateringID, isHired = true) {
    return new Promise((resolve, reject) => {
        let link = GLOBAL.FATHER_LINK + `/vendor/v1/foodtrucks/${truckID}/catering/${cateringID}/${isHired ? 'hired' : 'not-hired'}`;
        console.log(link);
        fetch(link, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + GLOBAL.DATA.USER_TOKEN
            }
        })
            .then((response) => {
                const statusCode = response.status;

                // Parse response to JSON
                response.json()
                    .then((finalResponse) => {
                        if (!finalResponse.hasOwnProperty('errors')) {
                            console.log(`[SUCCESS] MARK CATERING AS ${isHired ? '' : 'NOT'} HIRED`, finalResponse);
                            resolve(finalResponse);
                        }
                        else {
                            console.log(`[FAILED] MARK CATERING AS ${isHired ? '' : 'NOT'} HIRED (Status Code: ${statusCode})`, finalResponse);
                            reject(convertError(finalResponse['errors']));
                        }
                    });
            })
            .catch((error) => {
                console.log(`[FAILED] MARK CATERING AS ${isHired ? '' : 'NOT'} HIRED`, error);
                reject(error.message);
            });
    });
}
// endregion

// region POST - Submit Truck Feedback
export function submitCateringFeedback(truckID, cateringID, sales = 0, invoicingSalesCount = 0, feedback = '', weather = '', photos = [], isHood = false) {
    const formData = new FormData();
    formData.append('actual_sales', sales?.toString());
    formData.append('invoicing_sales', invoicingSalesCount?.toString());
    formData.append('weather', weather);
    if (feedback.trim()) formData.append('feedback', feedback);
    if (photos.length > 0) photos.forEach((item, index) => formData.append(`photos[${index}]`, item));

    const logLine = `SUBMIT ${isHood ? 'HOOD' : 'CATERING'} FEEDBACK`;

    return new Promise((resolve, reject) => {
        fetch(GLOBAL.FATHER_LINK + `/vendor/v1/foodtrucks/${truckID}/${isHood ? 'hoods' : 'catering'}/${cateringID}/${isHood ? 'hood' : 'catering'}-post-event`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + GLOBAL.DATA.USER_TOKEN
            },
            body: formData
        })
            .then((response) => handleFirstResponse(response))
            .then((response) => {
                if (!checkErrorExist(response)) {
                    console.log(`[SUCCESS] ${logLine}`, response);
                    resolve(response);
                }
                else {
                    console.log(`[FAILED] ${logLine}`, response);
                    reject(convertError(response.errors));
                }
            })
            .catch((error) => {
                console.log(`[FAILED] ${logLine}`, error);
                reject(error.message);
            });
    });
}
// endregion

// region Function - Mark Client Unresponsive
export function markClientUnresponsive(truckID = -1, cateringID = -1) {
    return apiWrapper(
        `/vendor/v1/foodtrucks/${truckID}/catering/${cateringID}/nonresponsive`,
        'POST',
        'MARK CLIENT UNRESPONSIVE'
    );
}
// endregion

// region Function - Create External Lead
export function createExternalCateringLead(truckID, cateringData = {}) {
    console.log('[INFO] CREATE EXTERNAL CATERING LEAD', cateringData);
    return apiWrapper(
        `/vendor/v2/foodtrucks/${truckID}/external-catering`,
        'POST',
        'CREATE EXTERNAL CATERING LEAD',
        JSON.stringify(cateringData),
        () => {},
        { 'Content-Type': 'application/json' }
    );
}
// endregion

// region Function - Update External Lead
export function updateExternalCateringLead(truckID, cateringData = {}) {
    console.log('[INFO] UPDATE EXTERNAL CATERING LEAD', cateringData);
    return apiWrapper(
        `/vendor/v2/foodtrucks/${truckID}/external-catering/${cateringData.id}`,
        'POST',
        'UPDATE EXTERNAL CATERING LEAD',
        JSON.stringify(cateringData),
        () => {},
        { 'Content-Type': 'application/json' }
    );
}
// endregion

// region Function - Send Invite for External Lead
export function sendInviteExternalCateringLead(truckID, cateringID = -1) {
    return apiWrapper(
        `/vendor/v2/foodtrucks/${truckID}/external-catering/${cateringID}/calendar-invitation`,
        'POST',
        'SEND INVITE FOR EXTERNAL CATERING LEAD',
    );
}
// endregion
